<div class="background-white col-10 p-0 aboutBg">

  <img src="assets/images/no-internet.png">

  <div class="internet-content">
    <h1>whoops!</h1>
    <h2>slow or no internet connection</h2>
    <h3>Check your internet settings and try again</h3>
    <button (click)="goHome()">Go Home</button>
  </div>

</div>




// WEBPACK FOOTER //
// ./src/app/template/noInternet/noInternet.component.html